import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Controller, EffectFade, Thumbs} from 'swiper/modules';

/**
 * Initializes Swiper sliders for all elements with the class '',
 * if such elements exist on the page.
 *
 * @returns {void}
 */
export const initializeTestimonialsSliders = () => {
    // Query all elements with the class ''
    const sliders = document.querySelectorAll('.js-testimonials-slider');

    // Check if any sliders exist
    if (sliders.length === 0) {
        return;
    }

    // Loop through each slider element and initialize Swiper for it
    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],
            loopAdditionalSlides: 1,
            loop: true,
            spaceBetween: 15,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 1.272,
                },
                500: {
                    slidesPerView: 1.5,
                },
                768: {
                    slidesPerView: 2.3,
                },
                992: {
                    slidesPerView: 2.8945,
                    spaceBetween: 44,
                },
            }
        });
    });
};

export const initializeMobileCompleatedProjects = () => {
    // Query all elements with the class ''
    const sliders = document.querySelectorAll('.js-mobile-project-slider');

    // Check if any sliders exist
    if (sliders.length === 0 || !window.matchMedia("(max-width: 767px)").matches) {
        return;
    }

    // Loop through each slider element and initialize Swiper for it
    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],
            loopAdditionalSlides: 1,
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            spaceBetween: 15,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });
};

export const initializeProjectSliders = () => {
    // Query all elements with the specified classes
    const sliders = document.querySelectorAll('.js-project-slider');
    const thumbnails = document.querySelectorAll('.js-project-thumbnails-slider');

    // Check if any sliders or thumbnails exist
    if (sliders.length === 0 || thumbnails.length === 0) {
        return;
    }

    // Loop through each slider and its corresponding thumbnails
    sliders.forEach((slider, index) => {
        const thumbnailsSlider = thumbnails[index]; // Match slider with its corresponding thumbnails

        // Initialize the main slider
        const mainSwiper = new Swiper(slider, {
            modules: [EffectFade, Controller],
            slidesPerView: 1,
            effect: 'fade',
            loop: true,
            spaceBetween: 15,
        });

        // Initialize the thumbnails slider
        const thumbnailSwiper = new Swiper(thumbnailsSlider, {
            modules: [Navigation, Thumbs],
            loop: true,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            loopAdditionalSlides: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: mainSwiper,
            },
            breakpoints: {
                320: {
                    spaceBetween: 15,
                    slidesPerView: 1.4708,
                },
                500: {
                    spaceBetween: 27,
                    slidesPerView: 1.4708,
                },
                992: {
                    slidesPerView: 2,
                },
            },
        });

        if (slider.classList.contains('style-2') && window.matchMedia("(max-width: 991px)").matches) {
            mainSwiper.changeLanguageDirection('rtl');
            thumbnailSwiper.changeLanguageDirection('rtl');
        }

        // Link the main slider and the thumbnails slider
        // mainSwiper.controller.control = thumbnailSwiper;
        // thumbnailSwiper.controller.control = mainSwiper;
    });
};